// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyQuote_root__3rrs1"};